import { render, staticRenderFns } from "./bug.vue?vue&type=template&id=65c67af4&"
import script from "./bug.vue?vue&type=script&lang=js&"
export * from "./bug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports